/**
 * Shared inline styles for the local-dev floating panels (DevTools,
 * DevSeedTools). Inline styles keep the dev panel free of any dependency on
 * the product's SCSS pipeline.
 */
import type * as React from 'react';

export const btnStyle: React.CSSProperties = {
  padding: '8px 12px',
  fontSize: 12,
  fontFamily: 'monospace',
  background: '#1a2035',
  color: '#8899bb',
  border: '1px solid #2a3555',
  borderRadius: 6,
  cursor: 'pointer',
  textAlign: 'left',
};

export const dangerBtnStyle: React.CSSProperties = {
  ...btnStyle,
  background: '#2a1015',
  color: '#ef4444',
  border: '1px solid #5c2020',
};
